import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const InputGroup = ({ label, value, onChange, placeholder, multiline, onDrop }) => {
    const [isDragOver, setIsDragOver] = useState(false);
    const { isDarkMode } = useTheme();

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        if (onDrop) onDrop(e);
    };

    const inputClasses = `w-full p-3 rounded-lg border text-sm transition-all focus:ring-2 focus:ring-blue-100 outline-none
        ${isDarkMode
            ? 'bg-slate-800 border-slate-700 text-white placeholder-slate-500 focus:border-blue-500'
            : 'bg-white border-slate-200 text-slate-800 focus:border-blue-500'}
        ${isDragOver
            ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-100'
            : ''}
    `;

    return (
        <div className="mb-3">
            <label className={`block text-xs font-medium mb-1 uppercase tracking-wide ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{label}</label>
            {multiline ? (
                <textarea
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`${inputClasses} resize-y min-h-[100px]`}
                />
            ) : (
                <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={inputClasses}
                />
            )}
        </div>
    );
};

export default InputGroup;
